import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitInternalStakeholdersTask extends Task {
    constructor(assetLibrary, internalStakeholdersConfig) {
        super();

        this.execute = (callback, progressCallback) => {
            const internalStakeholdersJson = assetLibrary.getAsset("internal-stakeholders-config");
            internalStakeholdersConfig.setPropertiesFromObject(internalStakeholdersJson);

            callback(this);
        }
    }
}